
export const onChangeText = setter => e => setter(e.target.value)